import { getDataCollectionTask } from '@/services/implementationmanagement.api';
import { formatDateToWrittenDate } from '@/helpers/dates';
import { icons } from '@/assets/icons'

export async function buildSubcontractorQuestionnaire(taskId) {

    // Call identity verification API to get the status of the identity verification process
    var response = await getDataCollectionTask(taskId);

    if(response.status !== 200 || response.data === null || response.data === undefined) {
        console.error('Error fetching data collection task');
        return null;
    }

    const task = response.data;

    const card = {
    id: task.taskId,
    title: task.taskName,
    subtitle: 'Help us understand your subcontractor requirements',
    progress: 0,
    subProgressMessage: '',
    status: task.taskStatus,
    route: '/tasks/subcontractor-questionnaire/' + task.taskId, 
    createdDate: new Date(task.createdDate),
    icon: icons.subcontractor
  }
    
  return card 
}

